import { Box, Divider, Stack, Typography } from "@mui/material";
import HelpIcon from '@mui/icons-material/Help';
import { CustomTooltip } from "src/content/keywordResearch/CustomTooltip";
import { newCardsCss } from "src/content/dashboard/DashboardCss";
import { keywordResearchDashBoardCss } from "src/content/keywordResearch/keywordResearchCSS";
import { KeywordOverviewResultCardsCss } from "src/content/keywordResearch/keywordOverview/keywordOverviewCSS";
import { ReviewAutomationSummaryData } from "../types";

interface AutomationSummaryProps {
  summaryData?: ReviewAutomationSummaryData;
}

function AutomationSummary({ summaryData }: AutomationSummaryProps) {
  const summaryList = [
    {
      id: 1,
      title: "New Reviews",
      value: summaryData?.newReviews ?? 0,
    },
    {
      id: 2,
      title: "Replies Posted",
      value: summaryData?.repliesPosted ?? 0,
    },
    {
      id: 3,
      title: "Skipped",
      value: summaryData?.skipped ?? 0,
    },
    {
      id: 4,
      title: "Failed",
      value: summaryData?.failed ?? 0,
    },
    {
      id: 5,
      title: "Avg. Response Time",
      value: summaryData?.avgResponseTimeSec !== undefined ? `${summaryData.avgResponseTimeSec}s` : "0s",
    },
  ];

  return (
    <div className="p-6">
      <Box>
        {/* Header */}
        <Box className="flex items-center gap-3 mb-4">
          <Typography sx={newCardsCss?.headTextCss}>
            Automation Summary
          </Typography>
          <CustomTooltip
            title={
              <Box>
                <Typography
                  sx={keywordResearchDashBoardCss?.customTollTipText}
                >
                  AI-generated overview highlighting your review automation metrics.
                </Typography>
              </Box>
            }
            placement="bottom"
            arrow
          >
            <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
          </CustomTooltip>
        </Box>

        {/* Summary */}
        <Stack
          direction="row"
          divider={
            <Divider
              orientation="vertical"
              flexItem
            />
          }
        >
          {summaryList.map((item) => (
            <Box
              key={item.id}
              flex={1}
              px={3}
            >
              <Stack
                direction="row"
                spacing={0.5}
                alignItems="center"
                mb={1}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "#686685",
                    fontWeight: 400,
                  }}
                >
                  {item.title}
                </Typography>

                <CustomTooltip
                  title={
                    <Box>
                      <Typography
                        sx={keywordResearchDashBoardCss?.customTollTipText}
                      >
                        AI-generated overview highlighting your review automation metrics.
                      </Typography>
                    </Box>
                  }
                  placement="bottom"
                  arrow
                >
                  <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
                </CustomTooltip>
              </Stack>

              <Typography
                variant="h3"
                sx={{
                  fontSize: "30px",
                  fontWeight: 700,
                  color: "#2E1065",
                  lineHeight: "38px",
                }}
              >
                {item.value}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>
    </div>
  );
}

export default AutomationSummary;
